import * as React from "react";

function SvgPlayNormal(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 320" {...props}><path d="M0 0v320l256-160L0 0z" /></svg>;
}

export default SvgPlayNormal;